module.exports = __webpack_public_path__ + "img/icon_map_63_off_111.df11e65d.png";